import { BusinessData } from '@/interfaces/billing'

export const getBusinessExchangeRate = (
  businessData: BusinessData | undefined,
  codeCurrency: string
): number => {
  const businessMain = businessData?.mainCurrency
  if (codeCurrency === businessMain) return 1
  return (
    businessData?.availableCurrencies.find((c) => c.code === codeCurrency)
      ?.exchangeRate ?? 1
  )
}

export const convertCurrency = (
  amount: number,
  fromCurrency: string,
  toCurrency: string,
  businessData: BusinessData | undefined
): number => {
  if (fromCurrency === toCurrency) return Number(amount.toFixed(2))
  const businessMain = businessData?.mainCurrency

  // Step 1: to business main currency
  let amountInBusinessMain = amount
  if (fromCurrency !== businessMain) {
    const fromRate = getBusinessExchangeRate(businessData, fromCurrency)
    amountInBusinessMain = amount * fromRate
  }

  // Step 2: from business main to target
  let result: number
  if (toCurrency === businessMain) {
    result = amountInBusinessMain
  } else {
    const toRate = getBusinessExchangeRate(businessData, toCurrency)
    result = amountInBusinessMain / toRate
  }
  return Number(result.toFixed(2))
}

export const formatCurrency = (
  amount: number,
  minimumFractionDigits = 2
): string => {
  return amount.toLocaleString('en-US', {
    minimumFractionDigits,
    maximumFractionDigits: 2,
  })
}

export const formatAmountWithCode = (
  amount: number,
  currency: string
): string => {
  // Always show two decimal places for monetary values regardless of currency
  const fractionDigits = 2
  const formatted = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount)
  return `${formatted} ${currency}`
}
